export default __webpack_public_path__ + "static/media/webcurtains.1d559149.png";